export default [
  { path: 
    '/academic',
    name: 'AcademicIndex',
    component: () => import('@/views/academic/Index'),
    meta: {
      breadcrumbs: [
        { text: 'งานกำหนดตำแหน่งทางวิชาการ' }
      ]
    }
  },
  { path: 
    '/academic/detail',
    name: 'Academic',
    component: () => import('@/views/academic/Academic'),
    meta: {
      breadcrumbs: [
        { text: 'งานกำหนดตำแหน่งทางวิชาการ', to: '/academic', disabled: false },
        { text: 'การขอกำหนดตำแหน่งทางวิชาการ' },
      ]
    }
  },
  { path: 
    '/academic/detail/:academic_id',
    name: 'AcademicDetail',
    component: () => import('@/views/academic/Detail'),
    meta: {
      breadcrumbs: [
        { text: 'งานกำหนดตำแหน่งทางวิชาการ', to: '/academic', disabled: false },
        { text: 'การขอกำหนดตำแหน่งทางวิชาการ', to: '/academic/detail', disabled: false },
        { text: 'การรายงานการดำเนินการ' },
      ]
    }
  },
  {
    path: '/academic/:mis_id/report',
    name: 'AcademicReport',
    component: () => import('@/views/academic/Report'),
    meta: {
      breadcrumbs: [
        { text: 'งานกำหนดตำแหน่งทางวิชาการ', to: '/academic', disabled: false },
        { text: 'รายงาน' },
      ]
    }
  }
];